/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { getProductions, getProduction } from 'redux/reducers/productions';
import { withRouter, Route } from 'react-router-dom';
import actions from 'redux/actions';
import { withTranslation } from 'react-i18next';

import type { Translate, Fetchable, Production, ReduxState } from 'types';

import { parseInt } from 'lodash';
import protonesUtils from 'utils/protones';

import CrudSidebar from 'components/CrudSidebar';
import ScrollableContent from 'components/ScrollableContent';
import ProductionIntro from './ProductionIntro';
import ProductionEdit from './ProductionEdit';
import ProductionShow from './ProductionShow';
import styles from './styles.module.scss';

const mapStateToProps = (state: ReduxState, ownProps) => {
  const { productionId } = ownProps.match.params;
  const isNew = productionId === 'create';
  return {
    isNew,
    productions: getProductions(state),
    production: getProduction(state),
    productionId: !isNew ? parseInt(productionId) : undefined,
    ...ownProps,
  };
};

type Props = {
  productions: Fetchable<Production[]>,
  production: Fetchable<Production>,
  isNew: boolean,
  productionId?: number,
  // actions
  fetchProductionList: typeof actions.fetchProductionList,
  fetchProduction: typeof actions.fetchProduction,
  createProduction: typeof actions.createProduction,
  saveProduction: typeof actions.saveProduction,
  deleteProduction: typeof actions.deleteProduction,
  match: any,
  t: Translate,
};

class Productions extends React.Component<Props, void> {
  componentDidMount() {
    const { isNew, productionId, fetchProduction, fetchProductionList } = this.props;
    fetchProductionList();
    if (!isNew && productionId) {
      fetchProduction(productionId);
    }
  }

  componentWillReceiveProps({ productionId: newProductionId }: Props) {
    const { productionId, fetchProduction } = this.props;
    if (newProductionId && newProductionId !== productionId) {
      fetchProduction(newProductionId);
    }
  }

  _handleRefreshProductionList = () => {
    this.props.fetchProductionList();
  };

  _handleCreateProduction = () => {
    this.props.createProduction();
    // $FlowFixMe
    protonesUtils.goTo(this.props, protonesUtils.routes.productions.create());
  };

  _handleSelectProduction = (id: number) => {
    this.props.fetchProduction(id);
    // $FlowFixMe
    protonesUtils.goTo(this.props, protonesUtils.routes.productions.get(id));
  };

  _handleEditProduction = (id: number) => {
    this.props.fetchProduction(id);
    // $FlowFixMe
    protonesUtils.goTo(this.props, protonesUtils.routes.productions.edit(id));
  };

  _handleDeleteProduction = (id: number) => {
    //eslint-disable-next-line
    if (confirm(this.props.t('ARE_YOU_SURE'))) {
      this.props.deleteProduction(id, () => {
        this.props.fetchProductionList();
        // $FlowFixMe
        protonesUtils.goTo(this.props, protonesUtils.routes.productions.find());
      });
    }
  };

  render() {
    const { productionId, isNew, productions, t } = this.props;
    return (
      <div className={styles.root}>
        <CrudSidebar
          title={t('PRODUCTIONS')}
          activeItemId={productionId}
          items={productions}
          onListRefresh={this._handleRefreshProductionList}
          onCreateItem={this._handleCreateProduction}
          onSelectItem={({ id }) => this._handleSelectProduction(id)}
          onEditItem={({ id }) => this._handleEditProduction(id)}
          onDeleteItem={({ id }) => this._handleDeleteProduction(id)}
        />
        <ScrollableContent>
          {isNew ? (
            <ProductionEdit />
          ) : !productionId ? (
            <ProductionIntro />
          ) : (
            <div style={{ height: '100%' }}>
              <Route exact path={`${this.props.match.url}/`} component={ProductionShow} />
              <Route exact path={`${this.props.match.url}/edit`} component={ProductionEdit} />
            </div>
          )}
        </ScrollableContent>
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(Productions)
  )
);
